import CustomImage from "components/atoms/Image/CustomImage";
import { useLang } from "hooks/useLang";
import { IArtist } from "./artistsSection";


const ArtistComponent = ({ _id, bio_ar, bio_en, name_ar, name_en, photo,route }: IArtist) => {
    const { lang } = useLang()
    const name = lang === "ar" ? name_ar : name_en
    const bio = lang === "ar" ? bio_ar : bio_en
   
    return <div key={_id} className="cursor-pointer   h-[100px] rounded-[10px] flex flex-row ">
        <div className="w-[40%] items-center relative flex  rounded-[6px] overflow-hidden ">
            <CustomImage fill alt={name}
                src={process.env.NEXT_PUBLIC_Event_Img_URL + photo}
                className="aspect-square object-cover rounded-[10px]"

            />
        </div>
        <div className=" w-[70%] flex flex-col justify-center   pl-4 gap-1">
            <span className="text-sm font-bold">{name}</span>
        </div>
    </div>
};


export default ArtistComponent